import React, { useContext } from 'react'
import styled from 'styled-components'
import { Relative, Absolute } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'
import PropTypes from 'prop-types'
import BootstrapDataContext from '../contexts/BootstrapDataContext'

const StyledContent = styled(Relative)`
    max-width: 1280px;
    margin: 0 auto;
`

const StyledWebBackgroundImage = styled(WebPBackgroundImage)`
  background-position: ${props => props.backgroundPosition ?? 'top left'};
  background-attachment: ${props => (props.isTablet ? 'unset' : 'fixed')};

  ${props => props.theme.mediaQueries[3]} {
    background-position: ${props => props.backgroundPosition ?? 'top right'};
  }
`

const Hero = ({ backgroundPosition, img, imgWebP, children, description }) => {
  const { isTablet = false } = useContext(BootstrapDataContext)

  return (
    <Relative>
      <StyledContent zIndex={10} pt={'32px'} pb={'40px'} px={4}>{children}</StyledContent>
      <Absolute bottom={0} left={0} right={0} top={0}>
        <StyledWebBackgroundImage
          backgroundPosition={backgroundPosition}
          image={img}
          imageWebP={imgWebP}
          height='100%'
          style={{
            backgroundColor: '#024fb2' // Dominant color from the linked image.
          }}
          alt={description}
          isTablet={isTablet}
          className='hero-image'
        />
      </Absolute>
    </Relative>
  )
}

Hero.displayName = 'Hero'

Hero.propTypes = {
  backgroundPosition: PropTypes.string,
  img: PropTypes.string,
  imgWebP: PropTypes.string,
  children: PropTypes.object,
  description: PropTypes.string
}

Hero.defaultProps = {
  description: 'Hero background Image',
  isTablet: false
}

export default Hero
